module.exports = __webpack_public_path__ + "img/bag.73412fac.svg";